
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { DistriApiService } from '../distri/distri.api.service';
import { CreerStockOp, CriteriaValue, Magasin } from '../../model/index';

@Injectable()
export class MagasinService {

    private readonly apiPath = 'common/magasins';

    constructor(private apiService: DistriApiService) {}

    getList() {
        return this.apiService.get(this.apiPath + '?size=1000').pipe(map((data: any) => data.content));
    }
    getListPaginate(size: number, page: number) {
        return this.apiService.get(this.apiPath + '?size=' + size + '&page=' + page);
    }

    findMagasin(criteria: CriteriaValue, size: number, page: number) {
        return this.apiService.post(this.apiPath + '/search/list-by-criteria?size=' + size + '&page=' + page, criteria);
    }
    findMagasin_count(criteria: CriteriaValue) {
        return this.apiService.post(this.apiPath + '/search/list-by-criteria/count', criteria);
    }

    listGestionnairePossible(magasin: Magasin) {
        return this.apiService.post(this.apiPath + '/search/list-gestionnaire-possible', magasin);
    }

    async findMagasinsGerant() {
        try {
            const data = await this.apiService.get(this.apiPath + '/search/all-magasins-avec-gerant').toPromise();
            return data;
        } catch (e) {
            console.log('findMagasinsGerant error', e);
            return [];
        }
    }

    findMagasinsAll() {
        return this.apiService.get(this.apiPath + '/search/magasins-all');
    }
    findByParentIsNull() {
        return this.apiService.get(this.apiPath + '/search/magasins-no-parent');
    }
    findByMagasinGere(loginAgent: string) {
        return this.apiService.get(this.apiPath + '/search/magasin-gere?loginAgent=' + loginAgent);
    }
    findMagasinsSup() {
        return this.apiService.get(this.apiPath + '/search/magasins-sup');
    }
    findMagasinsInf(parent: any) {
        return this.apiService.get(this.apiPath + '/search/magasins-inf?parent=' + parent);
    }
    findMagasinsBrothers(idMagasin: any, parent: any) {
        return this.apiService.get(this.apiPath + '/search/magasins-brothers?id=' + idMagasin + '&parent=' + parent);
    }

    getCurrentAgentMagasin() {
        return this.apiService.get(this.apiPath + '/search/current-agent-magasin');
    }

    findMagasinSource(magasinId: any) {
        return this.apiService.get(this.apiPath + '/search/transfert-source?m=' + magasinId);
    }
    findMagasinDemandeur(magasinId: any) {
        return this.apiService.get(this.apiPath + '/search/transfert-demandeur?m=' + magasinId);
    }

    findAllMagasinSource() {
        return this.apiService.get(this.apiPath + '/search/all-transfert-source');
    }
    findAllMagasinSource_Externe() {
        return this.apiService.get(this.apiPath + '/search/all-transfert-source-externe');
    }
    findAllMagasinDemandeur() {
        return this.apiService.get(this.apiPath + '/search/all-transfert-demandeur');
    }
    findAllMagasinDemandeur_Externe() {
        return this.apiService.get(this.apiPath + '/search/all-transfert-demandeur-externe');
    }

    findHistoriqueGerant(idMagasin: number, size: number, page: number) {
        return this.apiService.get(this.apiPath + '/search/historique-gerants?idMagasin=' + idMagasin + '&size=' + size + '&page=' + page);
    }

    saveGererStock(op: CreerStockOp) {
        return this.apiService.post(this.apiPath + '/op/save-gerer-stock', op);
    }
    saveGerantAgence(op: CreerStockOp) {
        return this.apiService.post(this.apiPath + '/op/save-gerant', op);
    }
    saveInfosOracle(op: CreerStockOp) {
        return this.apiService.post(this.apiPath + '/op/save-infos-oracle', op);
    }

    save(obj: Magasin) {
        return this.apiService.post(this.apiPath, obj);
    }
    update(obj: Magasin) {
        return this.apiService.put(this.apiPath, obj);
    }
    getElement(id: any) {
        return this.apiService.get(this.apiPath + '/' + id);
    }
    delete(id: any) {
        return this.apiService.delete(this.apiPath + '/' + id);
    }

    createCurrentAgentMagasinIfNotExist(nom: any) {
        return this.apiService.get(this.apiPath + '/op/creer-current-agent-magasin?nom=' + nom);
    }
}
